module.exports = __webpack_public_path__ + "img/health33_7-9-2021.7a0ebb0b.jpg";